module.exports = __webpack_public_path__ + "img/enamad.09c19dfa.png";